
const BASE_URL: string = 'https://test-customer-app-server.leada.de';

export const environment: Environment = {
  production: false,
  baseUrl: BASE_URL,
  timeStamp: '',
  apptext: {
    getTextsRoute: `${BASE_URL}/apptexts`,
  },
  auth: {
    loginRoute: `${BASE_URL}/auth/password`,
    logoutRoute: `${BASE_URL}/auth/logout`,
    resetPasswordRoute: `${BASE_URL}/users/resetpassword`,
    changePasswordRoute: `${BASE_URL}/users/password`,
  },
  user: {
    timeInfoRoute: `${BASE_URL}/users/timeinfo`,
    deviceRoute: `${BASE_URL}/users/device`,
    profileRoute: `${BASE_URL}/users/profile`,
    markBadgesDisplayedRoute: `${BASE_URL}/users/markbadgesdisplayed`,
    settingsRoute: `${BASE_URL}/users/settings`,
    markContentsDisplayedRoute: `${BASE_URL}/users/markcontentsdisplayed`,
    leaderRoute: `${BASE_URL}/users/leader`,
    targetGroupsRoute: `${BASE_URL}/users/targetgroups`,
    markLaunchReviewDoneRoute: `${BASE_URL}/users/marklaunchreviewdone`,
  },
  dialogs: {
    dialogsRoute: `${BASE_URL}/dialogs`,
    answerRoute: `${BASE_URL}/dialogs/answers`,
    dialogsStatsRoute: `${BASE_URL}/dialogs/stats`,
  },
  questions: {
    startRoute: `${BASE_URL}/questionchain`,
    answerRoute: `${BASE_URL}/questionchain`,
    buttonAgesRoute: `${BASE_URL}/questionchain/buttonages`,
  },
  reflection: {
    statusRoute: `${BASE_URL}/reflection/status`,
    nextQuestionTimeRoute: `${BASE_URL}/reflection/question_time/next`,
    currentQuestionTimeRoute: `${BASE_URL}/reflection/question_time/current`,
    skipReflectionRoute: `${BASE_URL}/reflection/skip`,
    skipOldReflectionsRoute: `${BASE_URL}/reflection/skip_all`,
  },
  tips: {
    ratingsRoute: `${BASE_URL}/tips/ratings`,
    postRatingRoute: `${BASE_URL}/tips/rating`,
    byType: `${BASE_URL}/tips/bytype`,
  },
  status: {
    stateRoute: `${BASE_URL}/state`,
  },
  week: {
    capacityRoute: `${BASE_URL}/capacity`,
  },
  history: {
    historyRoute: `${BASE_URL}/history`,
  },
  badge: {
    badgeRoute: `${BASE_URL}/badge`,
    calculateNewBadgesRoute: `${BASE_URL}/badge/calculatenew`,
  },
  content: {
    contentRoute: `${BASE_URL}/contents`,
    calculateNewContentsRoute: `${BASE_URL}/contents/recalc`,
    startRoute: `${BASE_URL}/contents/start`,
    pauseRoute: `${BASE_URL}/contents/pause`,
    resumeRoute: `${BASE_URL}/contents/resume`,
    restartRoute: `${BASE_URL}/contents/restart`,
    getPdfRoute: `${BASE_URL}/contents/pdf`,
  },
  cmodule: {
    cmoduleRoute: `${BASE_URL}/cmodules`,
  },
  goals: {
    goalsRoute: `${BASE_URL}/goals`,
    setStateRoute: `${BASE_URL}/goals/setstate`,
    feedbackRoute: `${BASE_URL}/goals/feedback`,
    downloadFileRoute: `${BASE_URL}/goals/download`,
  },
  theses: {
    thesesRoute: `${BASE_URL}/theses`,
    statsRoute: `${BASE_URL}/thesesstats`,
  },
  search: {
    searchRoute: `${BASE_URL}/search`,
  },
  firebase: {
    apiKey: 'AIzaSyCq3edOjBuEn3G9ZIhKbKBI_fupOmrphDw',
    authDomain: 'leada-bc71d.firebaseapp.com',
    databaseURL: 'https://leada-bc71d.firebaseio.com',
    projectId: 'leada-bc71d',
    storageBucket: 'leada-bc71d.appspot.com',
    messagingSenderId: '718673639042',
    appId: '1:718673639042:web:ffe1479a0393869469a69b',
    measurementId: 'G-BEJ2YM8WGB',
  },
  legacy: {
    psychologicalDetachment: `${BASE_URL}/leada-service/userdaydata/psychologicaldetachment`,
    relaxation: `${BASE_URL}/leada-service/userdaydata/relaxation`,
    masteryExperience: `${BASE_URL}/leada-service/userdaydata/masteryexperience`,
    energyLevelMorning: `${BASE_URL}/leada-service/userdaydata/morning/energylevel`,
    energyLevelEvening: `${BASE_URL}/leada-service/userdaydata/evening/energylevel`,
    performanceLevel: `${BASE_URL}/leada-service/userdaydata/performancelevel`,
    enablers: `${BASE_URL}/leada-service/userdaydata/enablers`,
    impediments: `${BASE_URL}/leada-service/userdaydata/impediments`,
    interactionStatus: {
      morning: `${BASE_URL}/leada-service/interaction/morning/status`,
      evening: `${BASE_URL}/leada-service/interaction/evening/status`,
      night: `${BASE_URL}/leada-service/interaction/night/status`,
    },
    tip: {
      usage: `${BASE_URL}/leada-service/interaction/tip/usage`,
    },
  },
};
